module.exports = "<suite-input-codes></suite-input-codes>\n"